import { Textarea } from '@payaca/ambrosia';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const TextareaFieldInput: FC<FieldProps<'textarea'>> = (props) => {
  const { value, onChange } = props;

  return <Textarea value={value ?? ''} onChange={onChange} />;
};
